import type { SVGProps } from 'react';

const SvgAlarm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.51 19.917c0 .324-.269.593-.593.593H4.083a.598.598 0 0 1-.593-.593c0-.325.269-.594.593-.594h15.834c.324 0 .593.269.593.594Z'
      fill='currentColor'
      opacity={0.4}
    />
    <path d='M19.125 14.375v4.948H4.875v-4.948a7.126 7.126 0 0 1 14.25 0Z' fill='currentColor' />
    <path
      d='M12 5.469a.598.598 0 0 1-.594-.594v-.792c0-.324.27-.594.594-.594.325 0 .594.27.594.594v.792c0 .324-.27.594-.594.594ZM6.458 7.052c-.15 0-.3-.055-.42-.174l-.79-.792a.597.597 0 0 1 0-.839c.229-.23.609-.23.838 0l.792.792c.23.23.23.61 0 .839a.587.587 0 0 1-.42.174ZM17.542 7.052c-.15 0-.301-.055-.42-.174a.597.597 0 0 1 0-.84l.792-.79c.23-.23.61-.23.839 0 .23.229.23.609 0 .838l-.792.792a.587.587 0 0 1-.42.174Z'
      fill='currentColor'
      opacity={0.4}
    />
  </svg>
);
export default SvgAlarm;
